// Справките рендират първите N реда и „Покажи още" — период „Тази година"
// иначе рисува стотици документи с всичките им редове наведнъж.
import { useEffect, useState } from "react";

export const SHOW_MORE_STEP = 100;

// `resetKey` се сравнява ПО СТОЙНОСТ: извикващите подават масив-литерал
// (`[period, filters, query]`), който е нов на всеки рендер — като
// зависимост на ефекта той връщаше лимита на 100 веднага след „Покажи още".
export const useShowMore = <T>(rows: T[], resetKey: unknown) => {
  const [limit, setLimit] = useState(SHOW_MORE_STEP);
  const key = typeof resetKey === "string" ? resetKey : JSON.stringify(resetKey);
  // нов филтър/период → отначало
  useEffect(() => setLimit(SHOW_MORE_STEP), [key]);
  return {
    visible: rows.slice(0, limit),
    hiddenCount: Math.max(0, rows.length - limit),
    showMore: () => setLimit((current) => current + SHOW_MORE_STEP),
  };
};
